import { WasmHandler } from "react-lib/frameworks/WasmController";
import { RequestToken } from "react-lib/apis/issara/manual";
import DentalExaminationFormList from "issara-sdk/apis/DentalExaminationFormList_apps_DEN";
import DentalExaminationFormDetail from "issara-sdk/apis/DentalExaminationFormDetail_apps_DEN";

export type DiagramState = {
  selectionMode?: boolean;
  dentalCariesRisk?: any;
  successForm?: boolean;
  activeTabDentalCaries?: number;
  openModAssessment?: boolean;
  assessmentResults?: 0 | 1 | 2 | null; //0: ความเสี่ยงต่ำ, 1: ความเสี่ยงกลาง, 2: ความเสี่ยงสูง
  openModalAssessmentResults?: boolean;
};

export const DiagramStateInitial = {
  selectionMode: false,
  dentalCariesRisk: {},
  activeTabDentalCaries: 0,
  openModalAssessmentResults: false,
  openModAssessment: false,
  assessmentResults: null,
};

const tissueFormMap = {
  dentalExamData: "tooth",
  dentalCariesRisk: "CariesRisk",
  faceExamData: "Head & Neck",
  muscleExamData: "Muscle & TMJ",
  periodontalExamData: "Periodontium",
  softTissueExamData: "Oral cavity",
};

export type DiagramEvent =
  | { message: "SetSelectionMode"; params: {} }
  | { message: "SetCheckedDentalCaries"; params: {} }
  | { message: "SetNextSectionDentalCaries"; params: {} }
  | { message: "SetActiveIndexDentalCaries"; params: { index: number } }
  | { message: "CloseModalDentalExam"; params: {} }
  | { message: "SaveAssessmentForm"; params: {} }
  | { message: "SaveEvaluationForm"; params: {} }
  | { message: "GetEvaluationFormList"; params: {} };

type Handler = WasmHandler<DiagramState, DiagramEvent>;

export const setSelectionMode: Handler = (controller, params) => {
  // const selectionMode: boolean = controller.getState().selectionMode
  // const selectionMode: boolean = controller.getState().selectionMode
  // this.setState({ selectorMode: true, editRow: row_index })
  // let prepareToothWithRecord = findSectionFromToothRecord(this.clinicalFindings[row_index])
  // this.setState({ multiSelected: prepareToothWithRecord })
  // controller.setState({selectorMode: true})
};

export const SetCheckedDentalCaries: Handler = (controller, params) => {
  const state = controller.getState();
  let cloneCaries = { ...state.dentalCariesRisk };
  if (!Object.keys(cloneCaries)[0]) {
    cloneCaries = JSON.parse(JSON.stringify(DentalCariesData));
  }
  const removeLastNumber = params.name.replace(/\d+$/i, "");

  cloneCaries[`${removeLastNumber}1`].value = false;
  cloneCaries[`${removeLastNumber}2`].value = false;
  if (!params.input && typeof cloneCaries[`${removeLastNumber}3`]?.value !== "string") {
    if (cloneCaries[`${removeLastNumber}3`]?.value) {
      cloneCaries[`${removeLastNumber}3`].value = false;
    }
  } else {
    if (!cloneCaries[`${removeLastNumber}1`].value && params.input) {
      cloneCaries[`${removeLastNumber}2`].value = true;
    }
  }
  cloneCaries[params.name].value = params.value;
  cloneCaries[params.name].text = params.text;

  if (params.name) {
    controller.setState({ dentalCariesRisk: cloneCaries });
  }
};

export const GetEvaluationFormList: Handler = async (controller, params) => {
  const [r, e, n] = await DentalExaminationFormList.list({
    apiToken: controller.apiToken,
    params: params,
  });

  console.log("params", params);
  if (e) {
    console.log("GetEvaluationFormList error: ", e);
    return;
  }

  const getFormData = () => {
    const object:Record<string, any> = {}
    for (const key in tissueFormMap) {
      object[key] = {};
    }
    return object;
  }

  const settingForm = getFormData()

  // console.log("GetEvaluationFormList:", r);
  if (r.items.length > 0) {
    let formDataList = r.items;
    formDataList = r.items.map((item: any) => {
      item.data = JSON.parse(item.data);
      return item;
    });

    for (const formI of formDataList) {
      settingForm[formI.data.form] = { ...formI.data, id: formI.id };
    }
    console.log("SETFORM DATA:", settingForm);
    controller.setState({
      ...settingForm,
    });
  } else if (r.items.length === 0) {
    controller.setState({
      ...settingForm,
    });
  }
};

export const SaveEvaluationForm: Handler = async (controller, params) => {
  const state = controller.getState();
  const jsonData = JSON.stringify({ ...state[params.form], form: params.form });
  console.log("SaveEvaluationForm:", params.form, state[params.form]);
  if (state[params.form]?.id) {
    const [r, e, n] = await DentalExaminationFormDetail.patch({
      pk: state[params.form].id,
      apiToken: controller.apiToken,
      data: {
        encounter: state.encounterId,
        tissue_name: tissueFormMap[params.form],
        data: jsonData,
      },
    });
    if (e) {
      console.log("Update Evaluation form:", e);
    } else {
      console.log("Update form complete", r);
      let form = params.form;
      controller.setData({
        ...state,
        form: {
          ...state[form],
          id: r.id,
        },
      });

      if (params.form === "dentalCariesRisk") {
        controller.setState({ 
          openModalAssessmentResults: false,
          activeTabDentalCaries: 0
        });
      }
    }
  } else {
    const [r, e, n] = await DentalExaminationFormList.create({
      apiToken: controller.apiToken,
      data: {
        encounter: state.encounterId,
        tissue_name: tissueFormMap[params.form],
        data: jsonData,
      },
    });
    if (e) {
      console.log("Create Evaluation form:", e);
    } else {
      let form = params.form;
      console.log("Create form complete", r);
      controller.setData({
        ...state,
        form: {
          ...state[form],
          id: r.id,
        },
      });

      if (params.form === "dentalCariesRisk") {
        controller.setState({
          openModalAssessmentResults: false,
          activeTabDentalCaries: 0,
        });
      }
    }
  }
};

export const SetNextSectionDentalCaries: Handler = (controller, params) => {
  const state = controller.getState();
  if (state.activeTabDentalCaries === 2) {
    let success = true;
    let riskLevelList = [];
    for (const [key, value] of Object.entries(DentalCariesData)) {
      const removeLastNumber = key?.replace(/\d+$/i, "");
      const checked = [1, 2, 3].find((number) => state.dentalCariesRisk?.[`${removeLastNumber}${number}`]?.value);

      if (!checked) {
        success = false;
      } else {
        if (`${removeLastNumber}${checked}` === key) {
          riskLevelList.push(state.dentalCariesRisk[key].riskLevel);
        }
      }
    }
    if (success) {
      let level: 0 | 1 | 2 | null = 0;
      if (riskLevelList.includes(1)) {
        level = 1;
      }
      if (riskLevelList.includes(2)) {
        level = 2;
      }
      controller.setState({
        openModalAssessmentResults: true,
        assessmentResults: level,
        dentalCariesRisk: { ...state.dentalCariesRisk, assessmentResults: level },
      });
    } else {
      controller.setState({
        openModAssessment: true,
      });
    }
    return;
  }
  controller.setState({
    activeTabDentalCaries: (state.activeTabDentalCaries || 0) + 1,
  });
};

export const SetActiveIndexDentalCaries: Handler = (controller, params) => {
  controller.setState({
    activeTabDentalCaries: params.index,
  });
};

export const CloseModalDentalExam: Handler = (controller) => {
  controller.setState({
    dentalCariesRisk: {},
    activeTabDentalCaries: 0,
    openModalAssessmentResults: false,
    assessmentResults: null,
  });
};

export const SaveAssessmentForm: Handler = (controller) => {
  const { dentalCariesRisk } = controller.getState();
  CloseModalDentalExam(controller);
};

//level 0:ความเสี่ยงต่ำ, 1:ความเสี่ยงกลาง, 2:ความเสี่ยงสูง, null input value
const DentalCariesData = {
  sec1No1Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec1No1Choice2: {
    value: false,
    riskLevel: 2,
  },
  sec1No2Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec1No2Choice2: {
    value: false,
    riskLevel: 2,
  },
  sec1No3Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec1No3Choice2: {
    value: false,
    riskLevel: 1,
  },
  sec1No4Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec1No4Choice2: {
    value: false,
    riskLevel: 1,
  },
  // sec1No4Choice3: {
  //   value: "",
  //   riskLevel: null,
  // },
  sec1No5Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec1No5Choice2: {
    value: false,
    riskLevel: 1,
  },
  // sec1No5Choice3: {
  //   value: "",
  //   riskLevel: null,
  // },
  sec1No6Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec1No6Choice2: {
    value: false,
    riskLevel: 1,
  },

  sec2No1Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec2No1Choice2: {
    value: false,
    riskLevel: 1,
  },
  sec2No1Choice3: {
    value: false,
    riskLevel: 2,
  },
  sec2No2Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec2No2Choice2: {
    value: false,
    riskLevel: 1,
  },
  sec2No3Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec2No3Choice2: {
    value: false,
    riskLevel: 1,
  },
  sec2No3Choice3: {
    value: false,
    riskLevel: 2,
  },
  sec2No4Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec2No4Choice2: {
    value: false,
    riskLevel: 1,
  },

  sec3No1Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec3No1Choice2: {
    value: false,
    riskLevel: 1,
  },
  sec3No1Choice3: {
    value: false,
    riskLevel: 2,
  },
  sec3No2Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec3No2Choice2: {
    value: false,
    riskLevel: 2,
  },
  sec3No3Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec3No3Choice2: {
    value: false,
    riskLevel: 1,
  },
  sec3No4Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec3No4Choice2: {
    value: false,
    riskLevel: 1,
  },
  sec3No5Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec3No5Choice2: {
    value: false,
    riskLevel: 1,
  },
  sec3No6Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec3No6Choice2: {
    value: false,
    riskLevel: 1,
  },
  sec3No7Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec3No7Choice2: {
    value: false,
    riskLevel: 1,
  },
  sec3No8Choice1: {
    value: false,
    riskLevel: 0,
  },
  sec3No8Choice2: {
    value: false,
    riskLevel: 2,
  },
  // sec3No9Choice1: {
  //   value: false,
  //   riskLevel: 0,
  // },
  // sec3No9Choice2: {
  //   value: false,
  //   riskLevel: 2,
  // },
};
